module.exports = __webpack_public_path__ + "static/media/12SegLoading.f218810f.gif";